import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

import { sideSpacingOfHeaderFooter } from '../../OrderCart.styles';

export const PreorderStatusBar = styled.div`
    ${sideSpacingOfHeaderFooter};
    padding-top: ${getPurpurSpacing('100')};
    padding-bottom: ${getPurpurSpacing('100')};
    background-color: ${getPurpurColor('brandOffBlack')};
    color: ${getPurpurColor('textDefaultNegative')};
    text-align: center;
    font-size: ${getPurpurTypography('scale75')};
    font-weight: ${getPurpurTypography('weightMedium')};
`;
